// @flow
export default (theme: Object) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
    },
    dialogContent: {
        overflowY: 'hidden',
        height: '100%',
        paddingBottom: 0,
    },
    dialogActions: {
        display: 'flex',
        justifyContent: 'center',
        margin: [[16, 12]],
    },
    dialogAction: {
        margin: 0,
    },
    submit: {
        '&:not($disabled)': {
            backgroundColor: theme.palette.success.main,
            color: theme.palette.common.white,
        },
    },
    submitLabel: {
        display: 'inline-block',
        fontFamily: 'Inter',
        fontSize: 14,
    },
    disabled: {},
});
